import { render, staticRenderFns } from "./RinvN_Details2.vue?vue&type=template&id=28c3a2da"
import script from "./RinvN_Details2.vue?vue&type=script&lang=js"
export * from "./RinvN_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports